import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../Navbar";
import Footer from "./Footer";
import SEO from "../components/SEO";

export default function DetailsProject() {
  const images = ["40.jpg", "41.jpg", "42.jpg", "43.jpg", "44.jpg"];
  const [mainImage, setMainImage] = useState(images[0]);

  return (
    <div className="project-page">
      <SEO
        title="Projet Immobilier — SCI MAYEDO"
        description="Découvrez ce projet immobilier proposé par SCI MAYEDO en Côte d'Ivoire. Villas et résidences de standing à Abidjan."
        canonical="/detail"
      />
      <Navbar />

      <main className="project-container">
        <div className="project-header">
          <h2 className="project-title">Cité des orchidées</h2>
          <p className="project-location">Abidjan, Côte d'Ivoire</p>
        </div>

        <section className="gallery-section">
          <div className="main-image">
            <img src={mainImage} alt="Image principale" />
          </div>

          <div className="thumbnails">
            {images.slice(1).map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`Thumbnail ${idx}`}
                className={mainImage === img ? "active" : ""}
                onClick={() => setMainImage(img)}
              />
            ))}
          </div>
        </section>

        <section className="project-description">
          <h5>Aperçu général</h5>
          <p>
            Le programme de la « Cité des Orchidées » est situé en plein cœur d’Abidjan,
            à Cocody Angré 7ème Tranche près du marché Cocovico. Il bénéficie d’un
            excellent emplacement et d’une architecture alliant modernité et confort.
          </p>

          <h5>Détails concernant le projet</h5>
          <ul>
            <li>21 appartements</li>
            <li>2 commerces (Magasins)</li>
            <li>1000 m²</li>
            <li>Parking privé</li>
          </ul>

          <h6>Conditions de location</h6>
          <ul>
            <li>2 mois de loyers d’avance</li>
            <li>2 mois de caution</li>
            <li>Honoraires d’agence (1 mois de loyer TCC) + TVA</li>
            <li>Frais de dossier (10 % du loyer mensuel) + TVA</li>
          </ul>

          <h6>Les charges comprennent :</h6>
          <ul>
            <li>2 places de parking pour les 4/5/6 pièces, 1 place pour les 3 pièces</li>
            <li>Entretien des parties communes, équipements (ascenseur, groupe électrogène...)</li>
            <li>Gardiennage</li>
          </ul>

          <h6>Frais annexes :</h6>
          <ul>
            <li>Compteur individuel d’électricité</li>
            <li>Abonnement internet et TV</li>
          </ul>

          <h6>Disponibilités :</h6>
          <Link to="/contact" className="availability-link">Nous consulter</Link>

          <div className="contact-button-wrapper">
            <Link to="/contact">
              <button className="contact-button">Réservez dès maintenant</button>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}